/**
 * Dynamically loads the appropriate highlight.js theme based on current color mode
 */

const HIGHLIGHT_THEME_ID = 'highlight-theme';

/**
 * Gets the current theme from localStorage and DOM
 * @returns {'light' | 'dark'} The current theme
 */
function getCurrentTheme() {
  const savedTheme = localStorage.getItem('theme');
  const isDark = savedTheme === 'dark' || document.documentElement.classList.contains('dark');
  return isDark ? 'dark' : 'light';
}

/**
 * Removes the existing highlight.js theme stylesheet
 */
function removeExistingTheme() {
  const existingTheme = document.getElementById(HIGHLIGHT_THEME_ID);
  if (existingTheme) {
    existingTheme.remove();
  }
}

/**
 * Loads the appropriate highlight.js theme CSS based on the current theme
 * @param {'light' | 'dark'} theme - The theme to load (optional, will auto-detect if not provided)
 */
export function loadHighlightTheme(theme) {
  const currentTheme = theme || getCurrentTheme();

  // Remove existing theme first
  removeExistingTheme();

  // Determine which highlight.js theme to load
  const themeFile = currentTheme === 'dark'
    ? 'tokyo-night-dark.css'
    : 'github.css';

  // Create and inject the new stylesheet
  const link = document.createElement('link');
  link.id = HIGHLIGHT_THEME_ID;
  link.rel = 'stylesheet';
  link.href = `https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.11.1/styles/${themeFile}`;

  document.head.appendChild(link);
}

/**
 * Sets up a listener for theme changes and updates syntax highlighting accordingly
 * Call this in components that use syntax highlighting
 */
export function setupThemeListener() {
  // Load initial theme
  loadHighlightTheme();

  // Listen for theme changes
  const handleThemeChange = (e) => {
    loadHighlightTheme(e.detail?.theme);
  };

  window.addEventListener('themechange', handleThemeChange);

  // Return cleanup function
  return () => {
    window.removeEventListener('themechange', handleThemeChange);
  };
}
